module.exports = __webpack_public_path__ + "static/media/wizualizacja-3.4516eb70.png";